export default __webpack_public_path__ + "static/media/dashbord.17625952.png";